module.exports = __webpack_public_path__ + "static/media/AW_250-Mama_desktop_hero_en.b70cb665.jpg";